import React from "react"
import {SosDonationCertificate, SosDonationProduct} from "../../../../packages/graphql-layer/src";
import CCOHeadline from "../../fundamentals/CCOHeadline";
import {FormProvider, useForm} from "react-hook-form";
import {DonationProductFormData} from "../../forms/F007ModularDonationForm/types";
import P020DonationProductForm from "./P020DonationProductForm";
import C085ProductTeaserContainer from "../../content/C085ProductTeaser/C085ProductTeaserContainer";
import {Box} from "@mui/material";

export interface Props {
    product: SosDonationProduct,
    CAEGlobalSettings: any
}

export interface ProductState {
    productQuantity: number;
    productGreeting: string;
    productFirstname: string;
    productSurname: string;
}

export function getQrCodeLink(product: SosDonationProduct) {
    let qrCodeLink = product?.landingPageLink && product?.landingPageLink.length > 0 ?
        product?.landingPageLink[0]?.canonicalUrl : "";
    return (qrCodeLink && qrCodeLink !== "") ? qrCodeLink : "";
}

export function getCertificate(product: SosDonationProduct) {
    return product?.donationCertificate && product?.donationCertificate.length > 0 ?
        (product?.donationCertificate[0] as SosDonationCertificate)?.id : undefined;
}

function P020DonationProduct(props: Props) {
    const headlineMargin = {b: 4, t: 4, l: 0, r: 0}
    const defaultProductState = {
        productQuantity: 1,
        productGreeting: '',
        productFirstname: '',
        productSurname: '',
        cmCsId: props.product.id
    } as ProductState;
    const formMethods = useForm<DonationProductFormData>({
        mode: 'onChange',
        reValidateMode: 'onChange',
        defaultValues: defaultProductState,
    });

    return <Box id='main'>
        <CCOHeadline metadataId={props.product.id}
                     type='h1'
                     propertyName='properties.title'
                     headline={props.product.title}
                     margin={headlineMargin}
                     dataCypress='donationProductHeadline'
        />
        <C085ProductTeaserContainer
            items={[props.product]}
            key={props.product.id}
            suppressRoofline={true}
        />
        <FormProvider {...formMethods}>
            <P020DonationProductForm product={props.product}/>
        </FormProvider>
    </Box>
}

export default P020DonationProduct